import { ResumeSkills } from "lib/redux/types";
import React from "react";

import {
  ResumePDFDescription,
  ResumePDFSkillsTwoColumn,
} from "../ResumePDF/common";
import { View } from "@react-pdf/renderer";
import { styles } from "../ResumePDF/styles";
import { TemplateEighteenPDFSectionPDF } from "./common";

 export const Skills = ({
  heading,
  skills,
  themeColor,
  showBulletPoints,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
  showBulletPoints?: boolean;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateEighteenPDFSectionPDF themeColor={themeColor} heading={heading}>
      <View wrap={false} style={{ ...styles.flexCol }}>
      <ResumePDFSkillsTwoColumn items={descriptions} />
      </View>
    </TemplateEighteenPDFSectionPDF>
  );
};


